// eslint-disable-next-line
// @ts-nocheck
import Nav from './nav';
import SvgManager from '../../core/SvgManager';

const icons = {
	open: '../images/OpenInTab.svg',
	add: '../images/New.svg',
	edit: '../images/Edit.svg',
	delete: '../images/Delete.svg'
};
SvgManager.enqueue(Object.values(icons));

const dashboardProperties = ['startPage', 'formId', 'itemId'];
const isDashboard = (item) => {
	const {
		additional_data: additionalData,
		'command_alias@aras.id': alias,
		'on_click_handler@aras.id': handler
	} = item;
	if (alias || handler) {
		return true;
	}

	if (!additionalData) {
		return false;
	}

	return (
		dashboardProperties.some((property) => additionalData[property]) ||
		!additionalData.itemTypeId
	);
};
const decorateTemplateForDelatedItem = (originFunction) => {
	return (item) => {
		const originalTemplate = originFunction(item);

		if (item.value['@aras.action'] === 'delete') {
			originalTemplate.props.draggable = false;
		}

		return originalTemplate;
	};
};

class NavEditor extends Nav {
	constructor() {
		super();

		this.modifier = 'editor';

		const { childNode, parentNode } = this.templates;
		this.templates.childNode = decorateTemplateForDelatedItem(childNode);
		this.templates.parentNode = decorateTemplateForDelatedItem(parentNode);
	}

	formatter(item) {
		const result = [];
		const {
			children,
			'@aras.action': action,
			related_id: relatedId
		} = item.value;
		const relatedItem = this.data.get(relatedId);
		const { image, name, label, '@aras.action': relatedAction } = relatedItem;
		const status = action || relatedAction;

		if (status) {
			if (status === 'delete') {
				result.push(<div className="aras-nav__deleted-row-mask"></div>);
			}

			const statusIndicatorClass = 'aras-nav__status-indicator';
			const icon = SvgManager.createInfernoVNode(icons[status], {
				cssClass: `${statusIndicatorClass}-icon`
			});
			const statusClass = `${statusIndicatorClass} ${statusIndicatorClass}_${status}`;
			result.push(<div className={statusClass}>{icon}</div>);
		}

		if (!children) {
			result.push(<span className="aras-nav__tree-levelpad" />);
		}

		if (image) {
			const iconNode = SvgManager.createInfernoVNode(image, {
				cssClass: `aras-nav__row__icon`
			});
			result.push(iconNode);
		}

		const labelNode = <span className="aras-nav__label">{label || name}</span>;
		result.push(labelNode);

		const isDashboardItem = isDashboard(relatedItem);
		if (!children && isDashboardItem) {
			result.push(
				<span className="aras-nav-leaf-ico">
					{SvgManager.createInfernoVNode(icons.open)}
				</span>
			);
		}

		return result;
	}
}

const name = 'aras-nav-editor';
if (!customElements.get(name)) {
	NavEditor.define(name);
}

export default NavEditor;
